<template lang="pug">
  div
    v-combobox(
      ref="ambassador_type_select"
      label="Type du contact"
      item-text="display_name"
      :items="items"
      :value="authorizedAmbassadorConfigs.filter(it => selectedIds.includes(it.id))"
      :menu-props="{ contentClass: 'ambassador-select-menu' }"
      multiple
      chips
      @change="editType"
      @blur="$refs.ambassador_type_select.isFocused = false; $refs.ambassador_type_select.isMenuActive = false;"
      :search-input.sync="search"
    )
      template(slot="item" slot-scope="props")
        .v-list__tile.px-3.theme--light.v-subheader.body-2.font-weight-bold(v-if="props.item.newType" @click.prevent.stop="openNewType") {{ props.item.newType }}
        .v-list__tile.px-3(v-else :class="props.tile.props.value ? 'primary--text' : ''")
          v-list-tile-action
            v-checkbox(:input-value="props.tile.props.value" color="primary")
          v-list-tile-content
            v-list-tile-title(v-html="highlightSearchedText(props.item.display_name)")
    v-dialog(
      v-model="newTagDialogIsOpen"
      width="30%"
      persistent
    )
      v-card
        v-card-title.white--text.title.primary.elevation-4
          v-layout.justify-center.align-center
            v-flex.xs10.offset-xs1.text-xs-center NOUVEAU TYPE DE CONTACT
            v-flex.xs1.text-xs-right
              v-icon(large dark @click="newTagDialogIsOpen = false; pendingType = null; pendingValues = null;") close
        v-card-text
          .subheading Vous allez créer un nouveau type de contact, veuillez rensiegner le nom et la catégorie de celui-ci :
          v-form.py-2(ref="newTypeForm")
            v-text-field.py-2(
              label="Nom du nouveau type"
              v-model="pendingType"
              :rules="[v => !!v || 'Veuillez renseigner le nom du nouveau type']"
            )
          v-layout.justify-end
            v-btn(color="error" @click="newTagDialogIsOpen = false; pendingType = null; pendingValues = null;") Annuler
            v-btn(color="success" @click="createType") Créer
</template>

<script>
import apiTypeService from '@/services/api/common/typeService';

export default {
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      foldedCategories: [],
      search: null,
      newTagDialogIsOpen: false,
      pendingType: null,
      pendingValues: null,
    }
  },
  computed: {
    authorizedAmbassadorConfigs() {
      return this.$store.state.contacts.types || [];
    },
    typeCategories() {
      return this.$store.state.contacts.typeCategories || [];
    },
    items() {
      const types = [...this.authorizedAmbassadorConfigs];
      return [{ newType: `Choisissez les types du contact ou ajoutez-en un` }, { divider: true }, ...types];
    }
  },
  watch: {
    search() {
      this.foldedCategories = [];
    }
  },
  methods: {
    async createType() {
      if(this.$refs.newTypeForm.validate()) {
        const newType = await apiTypeService.addContactType(this.pendingType);
        if (newType) {
          this.pendingValues.push(newType);
          this.$emit('change', this.pendingValues.map(it => it.id));
        }
        this.newTagDialogIsOpen = false;
        this.pendingType = null;
        this.pendingValues = null;
      }
    },
    toggleCategory(title) {
      if (this.foldedCategories.includes(title)) {
        this.foldedCategories.splice(this.foldedCategories.indexOf(title), 1);
      } else {
        this.foldedCategories.push(title);
      }
    },
    openNewType() {
      const values = this.$refs.ambassador_type_select.lazyValue;
      const existingValues = values.filter(it => typeof it === 'object' && !!it);
      setTimeout(() => {
        this.newTagDialogIsOpen = true;
        this.pendingValues = [...existingValues];
      }, 0);
    },
    editType(val) {
      this.search = null;
      const existingValues = val.filter(it => typeof it === 'object' && !!it);
      const newValue = val.find(it => typeof it === 'string');
      if (newValue) {
        setTimeout(() => {
          this.newTagDialogIsOpen = true;
          this.pendingType = newValue;
          this.pendingValues = [...existingValues];
        }, 0);
      } else {
        this.$emit('change', existingValues.map(it => it.id));
      }
    },
    highlightSearchedText(val) {
      return val.replace(new RegExp(this.search, 'i'), match => `<span class="v-list__tile__mask"">${match}</span>`);
    },
    filter(item, queryText, itemText) {
      const isHeader = item.header;
      const hasChildren = item.category && this.authorizedAmbassadorConfigs.some(it => it.display_name?.charAt(0) === item.title && it.display_name?.match(new RegExp(queryText, 'i')));
      const passesFilter = item.display_name && item.display_name.match(new RegExp(queryText, 'i'));
      return isHeader || hasChildren || passesFilter;
    }
  },
};
</script>

<style lang="scss">
  .ambassador-select-menu .v-list__tile {
    padding: 0;
  }
</style>
